import { colors } from 'baseui/tokens';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import { format } from 'date-fns';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import {
  AirlineContainer,
  AirlineContent,
  Container,
  GuestContent,
} from './styles';
import { TicketSaleFlightSaleFormType } from '../form-type';
import { flightSaleCalculation } from '../total-calculation';

interface Props {
  parentIdx: number;
  data: TicketSaleFlightSaleFormType;
}

export default function SummaryItem(props: Props) {
  const { t } = useTranslation();
  const { parentIdx, data } = props;
  const subtotal = React.useMemo(() => flightSaleCalculation(data), [data]);

  return (
    <Container>
      <>
        <Text
          variant="LabelMedium"
          $style={{ color: stylesColors.primaryDefault }}
        >
          {t('ticketSales:schedule_extra', {
            extra: `${parentIdx + 1}${
              data.bookingCode ? `- ${data.bookingCode}` : ''
            }`,
          })}
        </Text>
        {data.flightSaleGuests.map((guest, idx) => (
          <GuestContent key={guest.id || `${parentIdx}-guest-${idx}`}>
            <Text variant="LabelSmall">{guest.guestName}</Text>
            <SeparatorHorizontal $margin={8} />
            {guest.ticket && (
              <Text variant="LabelSmall" $style={{ color: colors.gray400 }}>
                ({guest.ticket?.toUpperCase()})
              </Text>
            )}
          </GuestContent>
        ))}
        {data.flightSaleAirlines.map((airline, idx) => (
          <AirlineContainer key={airline.id || `${parentIdx}-airline-${idx}`}>
            <AirlineContent>
              <Text variant="LabelSmall">{`${
                airline.date ? format(airline.date, 'dd-MM-yyyy') : '-'
              } | ${airline.detail || '-'} | ${airline.route || '-'} | ${
                airline.time || '-'
              } `}</Text>
              <SeparatorHorizontal $margin={8} />
              <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                {`@ Rp ${string2money(airline.price || 0)}`}
              </Text>
            </AirlineContent>
            <Text variant="LabelSmall">
              {`Rp ${string2money(
                (airline.price || 0) * (data.flightSaleGuests || []).length,
              )}`}
            </Text>
          </AirlineContainer>
        ))}
        {!!data.flightSaleAddOns.length && (
          <Container>
            <SeparatorVertical $margin={8} />
            <Text variant="ParagraphSmall" $style={{ color: colors.gray500 }}>
              {t('ticketSales:add_ons')}
            </Text>
            {data.flightSaleAddOns.map((addon, idx) => (
              <AirlineContainer key={addon.id || `${parentIdx}-addons-${idx}`}>
                <GuestContent>
                  <Text variant="LabelSmall">
                    {`${addon.guestName || '-'} | ${
                      addon.description || '-'
                    } | ${addon.route || '-'}` || ''}
                  </Text>
                  <SeparatorHorizontal $margin={8} />
                  <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                    {`@ Rp ${string2money(addon.price || 0)}`}
                  </Text>
                </GuestContent>
                <Text variant="LabelSmall">
                  {`Rp ${string2money(addon.price || 0)}`}
                </Text>
              </AirlineContainer>
            ))}
          </Container>
        )}
        <SeparatorVertical $margin={24}>
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </SeparatorVertical>
      </>
    </Container>
  );
}
